import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { SupplierOverlay } from '#app/routes/mocra+/_form+/components/suppliers/overlay.tsx'
import {
	createSupplierDraft,
	type SupplierDraft,
} from '#app/routes/mocra+/_form+/components/suppliers/types.ts'

type Props = {
	readonly onSubmit: (draft: SupplierDraft) => void
	readonly defaultValue?: SupplierDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function SupplierAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: SupplierDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add supplier'}
			</AddButton>
			<SupplierOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createSupplierDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
